import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { listPagePagination_template as pagination_template } from "~/components/templates/listPagePagination_template";
import { usersList_template } from "../components/templates/usersList_template";
import { header } from "./header";
import { hideLoadingOverlay, showLoadingOverlay } from "~/utils/listLoading";
export class users_list extends vnModule_knockoutJS {
    /**
     * @inheritDoc
     */
    getModuleName() {
        return "user_list";
    }
    /**
     * @inheritDoc
     */
    buildContent() {
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle("User List");
        // Create validation errors list template.
        // Create the users list.
        this.elementsList = new usersList_template("list", this.viewModel, this);
        return [this.elementsList.build()];
    }
    /**
     * @inheritDoc
     */
    fillPage() {
        this.getListFormData();
    }
    /**
     * Returns the list results container used for loading overlay.
     */
    getListResultsElement() {
        return this.elementsList?.builtTemplate?.querySelector?.('#list-results') ?? null;
    }
    /**
     * Requests data for the filters.
     */
    getListFormData() {
        const listResults = this.getListResultsElement();
        if (listResults) {
            showLoadingOverlay(listResults, "Loading users...");
        }
        // FB page filter.
        this.XHRHdl1 = new XMLHttpRequestHandler('/api/users/references/', [], this);
        this.XHRHdl1.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl1.execute();
    }
    /**
     * Hook.
     *
     * Redirects to profile page.
     *
     * @param id
     */
    viewUserProfile(id) {
        page(`/users/profile/${id}`);
    }
    /**
     * Hook.
     *
     * Redirects to create user page.
     */
    addUser() {
        page('/users/add');
    }
    /**
     * Hook.
     *
     * Initiates data refresh.
     */
    onShowActiveUsers() {
        this.getListData();
    }
    /**
     * Hook.
     *
     * Initiates data refresh.
     */
    paginationOnPageClick() {
        this.getListData();
    }
    /**
     * Hook.
     *
     * Initiates data refresh.
     */
    dataReorder() {
        this.getListData();
    }
    /**
     * Hook.
     *
     * Initiates data refresh.
     */
    filterMultipleSelectorOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.getListData();
    }
    /**
     * Hook.
     *
     * Cancels data request.
     */
    filterSimpleCancel() {
        if (this.XHRHdl2) {
            this.XHRHdl2.cancelAndReset();
        }
    }
    /**
     * Hook.
     *
     * Initiates data refresh.
     */
    filterSimpleOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.getListData();
    }
    /**
     * Fetches the list data.
     */
    getListData() {
        if (this.XHRHdl2) {
            this.XHRHdl2.cancelAndReset();
        }
        // LOADING : starts
        const listResults = this.getListResultsElement();
        if (listResults) {
            showLoadingOverlay(listResults, "Loading users...");
        }
        let usrReq_params = [];
        usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())]);
        this.XHRHdl2 = new XMLHttpRequestHandler('/api/users/get/', usrReq_params, this);
        this.XHRHdl2.onReadyStateFunction = this.onDataRequestReturn;
        this.XHRHdl2.execute();
    }
    /**
     * Returns handler for filter request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    onFilterRequestReturn(req, obj) {
        return function () {
            if (req.request.readyState !== 4) {
                return;
            }
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response || '{}');
                obj.updateFilters(responseParsed);
                obj.getListData();
            });
            if (req.request.status !== 200) {
                const listResults = obj.getListResultsElement();
                if (listResults) {
                    hideLoadingOverlay(listResults);
                }
            }
        };
    }
    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    onDataRequestReturn(req, obj) {
        return function () {
            if (req.request.readyState !== 4) {
                return;
            }
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response || '{}');
                obj.updateList(responseParsed);
            });
            const listResults = obj.getListResultsElement();
            if (listResults) {
                hideLoadingOverlay(listResults);
            }
        };
    }
    /**
     * Update the module list using the objects list.
     *
     * @param responseParsed
     */
    updateList(responseParsed) {
        let usersToSet = [];
        const items = Array.isArray(responseParsed?.data) ? responseParsed.data : [];
        for (let item of items) {
            const valnetUser = item?.valnet_user ?? {};
            const dateCreation = valnetUser.dateCreation
                ? String(valnetUser.dateCreation).substring(0, 10)
                : "";
            usersToSet.push({
                pictureUrl: valnetUser.pictureUrl ? `/usersImages/${valnetUser.pictureUrl}` : "/assets/images/default-user.png",
                fullName: valnetUser.fullName ?? "",
                loginName: valnetUser.loginName ?? "",
                email: valnetUser.email ?? "",
                dateCreation,
                id: item.id,
            });
        }
        let execTime = Math.round((new Date().getTime() - this.XHRHdl2.requestStartTime) / 1000 * 100) / 100;
        this.elementsList.setResultInfo(responseParsed?.totalCount ?? 0, responseParsed?.totalPage ?? 0, execTime);
        this.elementsList.setUsers(usersToSet);
        // Update the paginator.
        this.viewModel.list.pagination.itemCount(responseParsed?.totalCount ?? 0);
    }
    /**
     * Update the filters.
     *
     * @param responseParsed
     */
    updateFilters(responseParsed) {
        this.elementsList.setRoles(responseParsed.roles);
    }
}
